import { Outlet, createFileRoute } from '@tanstack/react-router';
import { validateAnalyticsSearch } from '@/features/analytics';

export const Route = createFileRoute('/_authed/analytics')({
  validateSearch: validateAnalyticsSearch,
  component: AnalyticsRouteLayout,
});

function AnalyticsRouteLayout() {
  return <Outlet />;
}
